'use client'
import { useEffect } from 'react'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import ReactMultiCarousel from 'react-multi-carousel'

import 'react-multi-carousel/lib/styles.css'
import SliderItem from './slider-item'

import { MOENGAGE_EVENT_NAME, trackMoengageEvent } from '@/libs/configs/moengage'
import {
  surveyIllustration,
  rewardIllustration,
  privacyIllustration,
} from '@/libs/constants/images-library'

const Carousel = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  useEffect(() => {
    trackMoengageEvent(MOENGAGE_EVENT_NAME.VIEW_ONBOARDING)
  }, [])

  return (
    <ReactMultiCarousel
      className='auth-slider relative z-50 flex-1'
      responsive={responsive}
      swipeable
      showDots
      dotListClass='!fixed lg:!absolute !bottom-20 lg:!bottom-4 !z-50'
      autoPlay
      autoPlaySpeed={5000}
      infinite
      customLeftArrow={
        <button className='absolute left-4 z-50 flex size-8 items-center justify-center rounded-full bg-white/30'>
          <MdChevronLeft className='size-8 text-white' />
        </button>
      }
      customRightArrow={
        <button className='absolute right-4 z-50 flex size-8 items-center justify-center rounded-full bg-white/30'>
          <MdChevronRight className='size-8 text-white' />
        </button>
      }
    >
      <SliderItem
        title='Earn with Responova'
        description='Earn real rewards by sharing your opinions. Join Responova and start earning today.'
        image={surveyIllustration}
      />
      <SliderItem
        title='Endless Surveys, Effortless Rewards'
        description='Explore a wide range of surveys that are quick and easy to complete. Participate effortlessly and start earning in minutes.'
        image={rewardIllustration}
      />
      <SliderItem
        title='Your Privacy is Safe'
        description='Your privacy and personal data are protected with advanced security measures and strict confidentiality.'
        image={privacyIllustration}
      />
    </ReactMultiCarousel>
  )
}

export default Carousel
